"use client"
import React from "react";
import CommunityDirectoryMemberView from "@/components/communities/CommunityDirectoryMemberView";

import "@/components/eventmanagement/EventParticipantGroupParticipantView.css";
import RichTextBlock from "@/components/shared/RichTextBlock";

const EventParticipantGroupParticipantView = ({
  name,
  point,
  locationTag,
  onClick,
  condensed
}) => {
  return (
    <div
      className="event-participant-view map-point-content"
      id={`map-point-content-${point ? point.id : "null"}`}
      onClick={onClick}
    >
      {point.participant && (
        <>
          <CommunityDirectoryMemberView
            size="sm"
            wrapperClassName=""
            className="event-participant-profile-view"
            profile={point.participant}
            external={false}
            sendToExternalWebsite={true}
            addTags={point.participantTags}
            locationTag={locationTag}
            showCoverPhoto={true}
            clickableLocation={true}
            enableDistanceTag={true}
            condensed={condensed}
          />
          {point.response &&
            point.response.responses &&
            point.response.responses.length > 0 && (
              <div className="event-participant-responses">
                {point.response.responses.map((response, index) => {
                  return (
                    <div className="event-participant-response">
                      <h6>{response.questionText}</h6>
                      <span>{response.response}</span>
                    </div>
                  );
                })}
              </div>
            )}
          {point.notesRichText && (
            <div className="event-participant-notes">
              <RichTextBlock
                richText={point.notesRichText}
                collapsable={false}
                as="span"
              />
            </div>
          )}
        </>
      )}
    </div>
  );
};
export default EventParticipantGroupParticipantView;
